import { TARIFF_PATTERNS, MODALITY_PATTERNS, VoltageType, ModalityType } from './tariff-constants';
import { TARIFFS_INDEXER } from './constants';

export const getTariffVoltageType = (tariffStr: string | null | undefined): VoltageType => {
  if (!tariffStr) return null;

  const str = String(tariffStr);

  // If the tariff is a numeric enum (e.g. 8, 9), lookup human-friendly info
  if (/^\d+$/.test(str)) {
    const idx = Number(str);
    const info = (TARIFFS_INDEXER as Record<string, { subgroup: string; tariff_modality: string }>)[idx];
    if (info) {
      const subgroup = String(info.subgroup).toLowerCase();
      if (subgroup.includes('baixa')) return 'LOW_VOLTAGE';
      // A-subgroups are medium voltage
      if (['a4', 'as', 'a3', 'a2'].some((s) => subgroup.includes(s))) return 'MEDIUM_VOLTAGE';
    }
    return null;
  }

  const lower = str.toLowerCase();

  if (TARIFF_PATTERNS.LOW_VOLTAGE.some((pattern) => lower.includes(pattern))) {
    return 'LOW_VOLTAGE';
  }

  if (TARIFF_PATTERNS.MEDIUM_VOLTAGE.some((pattern) => lower.includes(pattern))) {
    return 'MEDIUM_VOLTAGE';
  }

  return null;
};

export const getTariffModality = (tariffStr: string | null | undefined): ModalityType => {
  if (!tariffStr) return null;

  const str = String(tariffStr);

  // Numeric enum -> lookup tariff_modality
  if (/^\d+$/.test(str)) {
    const idx = Number(str);
    const info = (TARIFFS_INDEXER as Record<string, { subgroup: string; tariff_modality: string }>)[idx];
    if (info && typeof info.tariff_modality === 'string') {
      const mod = info.tariff_modality.toLowerCase();
      if (mod.includes('azul')) return 'BLUE';
      if (mod.includes('verde')) return 'GREEN';
    }
    return null;
  }

  const lower = str.toLowerCase();

  if (MODALITY_PATTERNS.BLUE.some((pattern) => lower.includes(pattern))) {
    return 'BLUE';
  }

  if (MODALITY_PATTERNS.GREEN.some((pattern) => lower.includes(pattern))) {
    return 'GREEN';
  }

  return null;
};

export const normalizeTariffString = (tariff: string | number | null | undefined): string => {
  if (!tariff) return '';
  return String(tariff).toLowerCase();
};
